import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

import { PrintLayout } from "components/Prints/PrintLayout";
import OrderPreparationDetailedPrint from "components/Prints/Orders/OrderPreparationDetailedPrint";
import OrderPreparationGroupedPrint from "components/Prints/Orders/OrderPreparationGroupedPrint";
import OrderPreparationPrintHeader from "components/Prints/Orders/OrderPreparationPrintHeader";
import { Order } from "types";

type Props = {
  open: boolean;
  orders: Order[];
  onClose: () => void;
};

export default function OrderPreparationReportsDialog({
  open,
  orders,
  onClose,
}: Props) {
  const groupedPrintRef = useRef<HTMLDivElement | null>(null);
  const detailedPrintRef = useRef<HTMLDivElement | null>(null);

  const handlePrintGrouped = useReactToPrint({
    content: () => groupedPrintRef.current,
  });

  const handlePrintDetailed = useReactToPrint({
    content: () => detailedPrintRef.current,
  });

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>Reportes de preparación</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography variant="body2">
              Los pedidos seleccionados ya fueron enviados a preparación.
            </Typography>
            <Typography variant="body2">
              Ahora podés generar:
            </Typography>
            <Typography variant="body2">
              A. Un reporte agrupado para operación en depósito.
            </Typography>
            <Typography variant="body2">
              B. Un reporte detallado para control y trazabilidad.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined">
            Cerrar
          </Button>
          <Button onClick={handlePrintGrouped} variant="contained" color="warning">
            Imprimir agrupado
          </Button>
          <Button onClick={handlePrintDetailed} variant="contained" color="success">
            Imprimir detallado
          </Button>
        </DialogActions>
      </Dialog>

      <PrintLayout
        ref={groupedPrintRef}
        headerInfo={
          <OrderPreparationPrintHeader
            title="Pedidos en preparación"
            subtitle="Reporte agrupado para operación de depósito"
            orders={orders}
            showClients
          />
        }
      >
        <OrderPreparationGroupedPrint orders={orders} />
      </PrintLayout>

      <PrintLayout
        ref={detailedPrintRef}
        headerInfo={
          <OrderPreparationPrintHeader
            title="Pedidos en preparación"
            subtitle="Reporte detallado para control y trazabilidad"
            orders={orders}
          />
        }
      >
        <OrderPreparationDetailedPrint orders={orders} />
      </PrintLayout>
    </>
  );
}
